module.exports = "<div class=\"css-loader\"><div></div><div></div><div></div><div></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/ts/Apps/CaseLookup/src/app/loader/loader.component.html
// module id = ./src/ts/Apps/CaseLookup/src/app/loader/loader.component.html
// module chunks = main